<template>
  <v-card style="box-shadow: none" >
    <v-toolbar flat id='manageTable'>
      <v-toolbar-title class='display-1 fontcolor'>{{TABLE_TITLE}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
     <template >
       <div class="mt-1" style="box-shadow: 0px 1px 3px rgba(9, 35, 58, 0.16);">
          <v-card-title class='body-1 fontcolor'>{{SEARCH_ADOPTION}}</v-card-title>
          <v-row class="ml-2 mr-2 mb-8 mt-2" >
            <v-col class="d-flex" cols="3" lg="3" sm="2" >
              <v-autocomplete
                class="caption"
                v-model="filterItem.stateId"
                :items='stateList'
                item-text='name'
                item-value='id'
                label="State"
                dense
                :loading="loadingState"
                @change='filterCounty'
              ></v-autocomplete>
            </v-col>
            <v-col class="d-flex" cols="3" lg="3" sm="2">
              <v-autocomplete
              class="caption"
              v-model="filterItem.countyId"
                :items='countyList'
                label="County"
                :item-text='customCountyName'
                item-value='id'
                dense
                :loading="loadingCounty"
                @change="filterJurisdiction"
              ></v-autocomplete>
          </v-col>
          <v-col class="d-flex" cols="3" lg="3" sm="2">
            <v-autocomplete
            class="caption"
            v-model="filterItem.jurisdictionId"
              :items='jurisdictionList'
              label="Jurisdiction"
              :item-text='customJurisdictionName'
              item-value='id'
              dense
              :loading="loadingJurisdiction"
              @keyup="onTextSearch"
              placeholder="Enter jurisdiction name"
            ></v-autocomplete>
          </v-col>
          <v-col class="d-flex" cols="3" lg="3" sm="2">
            <v-autocomplete
              class="caption"
              v-model="filterItem.townshipId"
              :items="townshipList"
              label="Township"
              :item-text='customTownshipName'
              item-value="id"
              dense
              :loading="loadingTownship"
            ></v-autocomplete>
          </v-col>
          <v-col class="d-flex" cols="3" lg="3" sm="2">
            <v-autocomplete
            multiple
            class="caption"
            v-model="filterItem.codeBookId"
              :items='codeBookList'
              label="Code Book Title"
              item-text='titleYear'
              item-value='id'
              dense
              :loading="loadingCodeBook"
            ></v-autocomplete>
          </v-col>
          <v-col class="d-flex" cols="3" lg="3" sm="2">
            <v-autocomplete
              multiple
              class="caption"
              v-model="filterItem.adoptionLableId"
              :items='adoptionLableList'
              label="Adoption Label"
              item-text='adoptionLabel'
              item-value='id'
              dense
              :loading="loadingCodeBook"
            ></v-autocomplete>
          </v-col>
          <v-col class="text-lg-right pa-0 mt-n4" cols="12">
            <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text small class='mr-2 text-lg-right text-capitalize' @click="initialize(1)">Reset</v-btn>
            </template>
            <span>Reset</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn  v-on="on" outlined class='mr-4 mb-2 text-lg-right' color="secondary" :disabled="exportButton" @click="exportCsv" :loading="!exportLoader"><v-icon>mdi-file-download</v-icon>Export CSV</v-btn>
            </template>
            <span>Export CSV </span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" outlined dark class='mb-2 fontcolor mr-2 text-lg-right' @click="onSearch" :loading="searchLoader"><v-icon>mdi-magnify</v-icon> Search</v-btn>
            </template>
            <span>Search</span>
          </v-tooltip>
          </v-col>
        </v-row>
       </div>
    </template>
    <v-data-table
    dense
    :loading='loading'
    :headers='headers'
    :items='adoptions'
    :page.sync="page"
    :options.sync= "options"
    :server-items-length="totalAdoptions"
    :items-per-page="itemsPerPage"
    class='elevation-1 for-table-ie'
    :footer-props="{'items-per-page-options': rowsPerPageItems
     }"
    >
      <template v-slot:item.countyName='{ item }' >
        <span v-if="item.adoptionById !== 3">{{ item.countyName }}</span>
      </template>
      <template v-slot:item.adoptionLabel='{ item }'>
        {{ item.adoptionLabel }} <template v-if="item.adoptionLabelPublisherAcronym">({{ item.adoptionLabelPublisherAcronym }})</template>
      </template>
      <template v-slot:item.created='{ item }' >
        <span class="caption font-weight-bold" >By: </span><span class="caption" >{{ item.createdBy }}</span>
        <br/>
        <span class="caption font-weight-bold" >On: </span><span class="caption" >{{ item.createdDate | customDateFormat }}</span>
      </template>
      <template v-slot:item.modified='{ item }' >
        <span class="caption font-weight-bold" >By: </span><span class="caption" v-if="item.modifiedBy" >{{ item.modifiedBy }}</span><span v-else>--</span>
        <br/>
        <span class="caption font-weight-bold" >On: </span><span class="caption" v-if="item.modifiedDate" >{{ item.modifiedDate | customDateFormat }}</span><span v-else>--</span>
      </template>
      <template v-slot:item.bookTitleYear="{ item }">
        <span v-if="typeof item.customBookTitleYear !== 'undefined' && item.customBookTitleYear !== ''">{{ item.customBookTitleYear }}</span>
        <span v-else >{{ item.bookTitleYear }}</span>
      </template>
      <template v-slot:no-data>
        <p>No proposed adoptions found</p>
      </template>
    </v-data-table>
    <v-row>
      </v-row>
  </v-card>
</template>

<script>
import CONSTANTS from './../../../../config/constant'
import { _ } from 'vue-underscore'

export default {
  name: 'AdminProposedAdoptionList',
  data: () => ({
    keyCode: [37, 38, 39, 40],
    TABLE_TITLE: CONSTANTS.MANAGE_PROPOSED_ADOPTIONS,
    NO_DATA_FOUND: CONSTANTS.NO_DATA_FOUND,
    defaultAdoptionItems: CONSTANTS.ADOPTION_STATUS,
    SEARCH_ADOPTION: CONSTANTS.SEARCH_ADOPTION,
    searchLoader: false,
    exportLoader: true,
    exportCSVLimit: CONSTANTS.EXPORT_CSV_LIMIT,
    exportButton: true,
    loading: false,
    loadingState: true,
    loadingCounty: true,
    loadingJurisdiction: false,
    loadingTownship: true,
    loadingCodeBook: true,
    editedIndex: -1,
    rowsPerPageItems: [5, 10, 20, 50, 100],
    options: {},
    page: 1,
    totalAdoptions: 0,
    itemsPerPage: 10,
    queryParams: '',
    tempJurisdictionList: [],
    tempTownshipList: [],
    adopLabList: [],
    csvHeaders: {
      // ID: 'ID',
      StateName: 'State Name',
      CountyName: 'County Name',
      JurisdictionName: 'Jurisdiction Name',
      TownshipName: 'Township Name',
      CodeBookName: 'Code Book Name',
      AdoptionLabel: 'Adoption Label',
      CreatedBy: 'Created By',
      CreatedDate: 'Created Date',
      ModifiedBy: 'Modified By',
      ModifiedDate: 'Modified Date'
    },
    headers: [
      {
        text: 'ID',
        align: 'left',
        sortable: true,
        value: 'id',
        class: 'subtitle-2 primaryColor'
      },
      {
        text: 'State',
        value: 'stateName',
        sortable: true,
        class: 'subtitle-2 primaryColor'
      },
      {
        text: 'County',
        value: 'countyName',
        sortable: true,
        class: 'subtitle-2 primaryColor'
      },
      {
        text: 'Jurisdiction',
        value: 'jurisdictionName',
        sortable: true,
        class: 'subtitle-2 primaryColor'
      },
      {
        text: 'Township',
        value: 'townshipName',
        sortable: false,
        class: 'subtitle-2 primaryColor'
      },
      {
        text: 'Code Book',
        value: 'bookTitleYear',
        sortable: true,
        class: 'subtitle-2 primaryColor'
      },
      {
        text: 'Adoption Label',
        value: 'adoptionLabel',
        sortable: true,
        class: 'subtitle-2 primaryColor'
      },
      {
        text: 'Created',
        value: 'created',
        sortable: false,
        class: 'subtitle-2 primaryColor'
      },
      {
        text: 'Modified',
        value: 'modified',
        sortable: false,
        class: 'subtitle-2 primaryColor'
      }
    ],
    filterItem: {
      id: '',
      stateId: '',
      countyId: '',
      jurisdictionId: '',
      codeBookId: '',
      customTitleId: '',
      adoptionStatus: '',
      adoptionLableId: '',
      townshipId: ''
    },
    defaultItem: {
      id: '',
      stateId: '',
      countyId: '',
      jurisdictionId: '',
      codeBookId: '',
      customTitleId: '',
      adoptionStatus: '',
      adoptionLableId: '',
      townshipId: ''
    }
  }),
  mounted () {
    this.onTextSearch = _.debounce(this.onTextSearch, 350)
    this.initialize()
  },
  watch: {
    options: {
      handler () {
        const formData = {
          id: this.filterItem.id === undefined ? '' : this.filterItem.id,
          stateId: this.filterItem.stateId === undefined ? '' : this.filterItem.stateId,
          countyId: this.filterItem.countyId === undefined ? '' : this.filterItem.countyId,
          jurisdictionId: this.filterItem.jurisdictionId === undefined ? '' : this.filterItem.jurisdictionId,
          townshipId: this.filterItem.townshipId === undefined ? '' : this.filterItem.townshipId,
          codeBookId: this.filterItem.codeBookId === undefined ? '' : this.filterItem.codeBookId,
          adoptionLableId: this.filterItem.adoptionLableId === undefined ? '' : this.filterItem.adoptionLableId
        }
        const { sortBy, sortDesc, page, itemsPerPage } = this.options
        const { id, stateId, countyId, jurisdictionId, townshipId, adoptionLableId, codeBookId } = formData
        let sortOrder = sortDesc[0] === true ? 'asc' : 'desc'
        if (sortBy.length === 1 || sortDesc.length === 1 || page !== 1 || itemsPerPage) {
          this.queryParams = `?page=${page}&itemsPerPage=${itemsPerPage}&sortBy=${sortBy}&direction=${sortOrder}&fId=${id}&fState=${stateId}&fCounty=${countyId}&fJurisdiction=${jurisdictionId}&fBook=${codeBookId}&fAdoptionLabel=${adoptionLableId}&fTownship=${townshipId}`
        }
        this.$store.commit('AdoptionModule/addQueryParams', this.queryParams)
        new Promise((resolve, reject) => {
          this.$store.dispatch('AdoptionModule/getProposedAdoptionList', {
            resolve,
            reject
          })
        })
          .then(responseData => {
            this.totalAdoptions = responseData.pagination.totalRecords
            this.loading = false
            this.totalAdoptions > this.exportCSVLimit ? this.exportButton = true : this.exportButton = false
          })
          .catch(response => {
          })
      },
      deep: true
    }
  },
  computed: {
    // to get logged in user ID
    userId () {
      return this.$store.getters['AuthModule/getUserId']
    },
    exportAdoptionList () {
      return this.$store.getters['AdoptionModule/fetchExportAdoptionList']
    },
    // to fetch adoption list
    adoptions () {
      return this.$store.getters['AdoptionModule/fetchAdoptionList']
    },
    countyList () {
      return this.$store.getters['CountyModule/fetchCountyList']
    },
    stateList () {
      return this.$store.getters['StateModule/fetchStateList']
    },
    // to fetch code book list
    codeBookList () {
      return this.$store.getters['CodeBookModule/fetchCodeBookList']
    },
    jurisdictionList () {
      return this.tempJurisdictionList.list
    },
    townshipList () {
      return this.tempTownshipList.list
    },
    adoptionLableList () {
      return this.adopLabList
    }
  },
  filters: {
    customDateFormat: function (value) {
      if (!value) return '--'
      value = value.toString()
      let date = new Date(value)
      return ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '-' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '-' + date.getFullYear()
    }
  },
  methods: {
    customCountyName: item => item.name + ', ' + item.stateAbbr,
    customJurisdictionName: item => item.name + ', ' + item.stateAbbr,
    customTownshipName: item => item.name + ', ' + item.countyName + ', ' + item.stateAbbr,
    searchJurisdition (formData) {
      new Promise((resolve, reject) => {
        this.$store.dispatch('JurisdictionModule/textJurisdictionSearch', {
          resolve,
          reject,
          formData
        })
      })
        .then(responseData => {
          this.tempJurisdictionList = responseData
        // add loader on button if required
        })
        .catch(response => {
          this.tempJurisdictionList = []
          // add loader on button if required
        })
    },
    onTextSearch (event) {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      const keyCode = this.keyCode
      const searchString = event.target.value
      const formData = {
        searchString: searchString,
        countyId: this.filterItem.countyId,
        stateId: this.filterItem.stateId,
        countryId: this.filterItem.countryId,
        status: fetchOnlyPublished
      }
      if (searchString.length >= 3) {
        if (!keyCode.includes(event.keyCode)) {
          this.searchJurisdition(formData)
        }
      } else {
        this.tempJurisdictionList = []
      }
    },
    // filter county on based on state selected
    filterCounty () {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      const stateId = this.filterItem.stateId
      const countryId = ''
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountyModule/getCountyList', {
          resolve,
          reject,
          countryId,
          stateId,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.tempCounty = responseData
          // add loader on button if required
        }
        )
        .catch(response => {
          this.tempCounty = []
          // add loader on button if required
        })
      // reset jurisdiction dropdown
      this.tempJurisdictionList = []
      new Promise((resolve, reject) => {
        this.$store.dispatch('TownshipModule/getFilteredTownshipList', {
          resolve,
          reject,
          countryId,
          stateId,
          fetchOnlyPublished
        })
      }).then(responseData => {
        this.tempTownshipList = responseData
        // add loader on button if required
      }).catch(response => {
        this.tempTownshipList = []
        // add loader on button if required
      })
    },
    filterJurisdiction () {
      // reset jurisdiction dropdown
      this.tempJurisdictionList = []
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      const stateId = this.filterItem.stateId
      const countryId = ''
      const countyId = this.filterItem.countyId
      new Promise((resolve, reject) => {
        this.$store.dispatch('TownshipModule/getFilteredTownshipList', {
          resolve,
          reject,
          countryId,
          stateId,
          countyId,
          fetchOnlyPublished
        })
      }).then(responseData => {
        this.tempTownshipList = responseData
        // add loader on button if required
      }).catch(response => {
        this.tempTownshipList = []
        // add loader on button if required
      })
    },
    // dispatch an action in below method to fetch adoption list
    initialize (callReset = 0) {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      Object.assign(this.filterItem, this.defaultItem)
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      if (sortBy.length === 1 || sortDesc.length === 1 || page !== 1 || itemsPerPage) {
        let st = ''
        st = typeof (sortBy) !== 'undefined' ? sortBy : ''
        let sd = ''
        st = typeof (sortDesc) !== 'undefined' ? sortDesc : ''
        this.queryParams = `?page=${page}&itemsPerPage=${itemsPerPage}&sortBy=${st}&direction=${sd}`
      }
      if (callReset === 1) {
        this.$store.commit('AdoptionModule/addQueryParams', this.queryParams)
        new Promise((resolve, reject) => {
          this.$store.dispatch('AdoptionModule/getProposedAdoptionList', {
            resolve,
            reject
          })
        })
          .then(responseData => {
            this.totalAdoptions = responseData.pagination.totalRecords
            this.loading = false
            this.totalAdoptions > this.exportCSVLimit ? this.exportButton = true : this.exportButton = false
          })
          .catch(response => {
          })
      }
      // dispatch an action in below method to fetch codebook list
      new Promise((resolve, reject, status) => {
        this.$store.dispatch('CodeBookModule/getCodeBookList', {
          resolve,
          reject,
          status
        })
      })
        .then(responseData => {
          this.loadingCodeBook = false
        })
        .catch(response => {
          this.loadingCodeBook = false
        })
      // dispatch an action in below method to fetch country list
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountryModule/getCountryList', {
          resolve,
          reject,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          // add loader on button if required
        })
        .catch(response => {
          // add loader on button if required
        })
      // dispatch an action in below method to fetch state list
      new Promise((resolve, reject) => {
        this.$store.dispatch('StateModule/getStateList', {
          resolve,
          reject,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.loadingState = false
        })
        .catch(response => {
          this.loadingState = false
        })
      // dispatch an action in below method to fetch adoption label list
      new Promise((resolve, reject, status) => {
        this.$store.dispatch('AdoptionLabelModule/getAdoptionLabelList', {
          resolve,
          reject,
          status
        })
      })
        .then(responseData => {
          this.adopLabList = responseData.list
        })
        .catch(response => {
        })
      // dispatch an action in below method to fetch adoption status list
      new Promise((resolve, reject, status) => {
        this.$store.dispatch('AdoptionStatusModule/getAdoptionStatusList', { resolve, reject, status })
      }).then((responseData) => {
      }).catch(response => {
      })
      // dispatch an action in below method to fetch adoption type list
      new Promise((resolve, reject) => {
        // let status = '' // use this parameter for record statue published/inactive
        this.$store.dispatch('AdoptionTypeModule/getAdoptionTypeList', { resolve, reject })
      }).then((responseData) => {
      }).catch(response => {
      })
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountyModule/getCountyList', {
          resolve,
          reject,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.loadingCounty = false
        })
        .catch(response => {
          this.loadingCounty = false
        })
      // reset jurisdiction dropdown
      this.tempJurisdictionList = []
      new Promise((resolve, reject) => {
        this.$store.dispatch('TownshipModule/getTownshipList', {
          resolve,
          reject,
          fetchOnlyPublished
        })
      }).then(responseData => {
        this.tempTownshipList = responseData
        this.exportButton = false
        this.loadingTownship = false
      }).catch(response => {
        this.loadingTownship = false
      })
    },
    convertToCSV (objArray) {
      var array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray
      var str = ''
      for (var i = 0; i < array.length; i++) {
        var line = ''
        for (var index in array[i]) {
          if (line !== '') line += ','
          line += array[i][index]
        }
        str += line + '\r\n'
      }
      return str
    },
    // export CSV function
    exportCsv () {
      this.exportLoader = false
      this.loading = true
      this.onSearch(true)
      this.loading = false
    },
    exportCSVFile (headers, items, fileTitle) {
      if (headers) {
        items.unshift(headers)
      }
      // Convert Object to JSON
      var jsonObject = JSON.stringify(items)
      var csv = this.convertToCSV(jsonObject)
      var exportedFilenmae = fileTitle + '.csv' || 'export.csv'
      var blob = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), csv], { type: 'text/plain;charset=utf-8' })
      if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae)
      } else {
        var link = document.createElement('a')
        if (link.download !== undefined) { // feature detection
        // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', exportedFilenmae)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }
    },
    download () {
      var headers = this.csvHeaders
      var itemsNotFormatted = this.exportAdoptionList
      var itemsFormatted = []
      // format the data
      itemsNotFormatted.forEach((item) => {
        let bookName = item.customBookTitleYear !== '' ? item.customBookTitleYear : item.bookTitleYear
        itemsFormatted.push({
          // ID: item.id,
          stateName: item.stateName,
          countyName: item.countyName,
          jurisdictionName: item.jurisdictionName,
          townshipName: item.townshipName,
          codeBookName: bookName.replace(/,/g, ''),
          adoptionLabel: item.adoptionLabel.replace(/,/g, ''),
          createdBy: item.createdBy,
          createdDate: item.createdDate,
          modifiedBy: item.modifiedBy,
          modifiedDate: item.modifiedDate
        })
      })
      var fileTitle = 'adoption_record_' + Date.now() // make unique file name'
      this.exportCSVFile(headers, itemsFormatted, fileTitle) // call the exportCSVFile() function to process the JSON and trigger the download
    },
    // On Click of Search Filter Button
    onSearch (isExportCSV = false) {
      const formData = {
        id: this.filterItem.id === undefined ? '' : this.filterItem.id,
        stateId: this.filterItem.stateId === undefined ? '' : this.filterItem.stateId,
        countyId: this.filterItem.countyId === undefined ? '' : this.filterItem.countyId,
        jurisdictionId: this.filterItem.jurisdictionId === undefined ? '' : this.filterItem.jurisdictionId,
        townshipId: this.filterItem.townshipId === undefined ? '' : this.filterItem.townshipId,
        codeBookId: this.filterItem.codeBookId === undefined ? '' : this.filterItem.codeBookId,
        adoptionLableId: this.filterItem.adoptionLableId === undefined ? '' : this.filterItem.adoptionLableId
      }
      let { sortBy, sortDesc, itemsPerPage } = this.options
      const page = 1
      if (isExportCSV === true) {
        itemsPerPage = this.totalAdoptions
      }
      let sortOrder = sortDesc[0] === true ? 'asc' : 'desc'
      let sb = typeof (sortBy[0]) === 'undefined' ? 'id' : sortBy[0]
      const { id, stateId, countyId, jurisdictionId, townshipId, adoptionLableId, codeBookId } = formData
      if (sortBy.length === 1 || sortDesc.length === 1 || itemsPerPage) {
        this.queryParams = `?page=${page}&itemsPerPage=${itemsPerPage}&sortBy=${sb}&direction=${sortOrder}&fId=${id}&fState=${stateId}&fCounty=${countyId}&fJurisdiction=${jurisdictionId}&fBook=${codeBookId}&fAdoptionLabel=${adoptionLableId}&fTownship=${townshipId}`
      }
      this.$store.commit('AdoptionModule/addQueryParams', this.queryParams)
      if (isExportCSV === true) {
        this.exportLoader = false
        new Promise((resolve, reject) => {
          this.$store.dispatch('AdoptionModule/getExportPoposedAdoptionList', {
            resolve,
            reject
          })
        })
          .then(responseData => {
            this.totalAdoptions = responseData.pagination.totalRecords
            this.loading = false
            this.totalAdoptions > this.exportCSVLimit ? this.exportButton = true : this.exportButton = false
            this.download()
            this.exportLoader = true
          })
          .catch(response => {
            // removed snackbar purposefully(as no need to show error if record not found)
            this.exportLoader = true
          })
      } else {
        this.searchLoader = true
        new Promise((resolve, reject) => {
          this.$store.dispatch('AdoptionModule/getProposedAdoptionList', {
            resolve,
            reject
          })
        })
          .then(responseData => {
            this.totalAdoptions = responseData.pagination.totalRecords
            this.loading = false
            this.totalAdoptions > this.exportCSVLimit ? this.exportButton = true : this.exportButton = false
            this.searchLoader = false
          })
          .catch(response => {
            // removed snackbar purposefully(as no need to show error if record not found)
            this.searchLoader = false
            this.exportButton = true
          })
      }
    }
  }
}
</script>
